import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Heart, Copy, Check } from "lucide-react";
import { toast } from "sonner";

const QUOTE_IMG = "https://images.unsplash.com/photo-1599659593072-10de2e109486?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Donate() {
  const [methods, setMethods] = useState([]);
  const [copied, setCopied] = useState("");

  useEffect(() => { api.get("/donations/info").then((r) => setMethods(r.data.methods || [])).catch(() => {}); }, []);

  const copy = (val, key) => {
    navigator.clipboard.writeText(val);
    setCopied(key);
    toast.success("Copied");
    setTimeout(() => setCopied(""), 1500);
  };

  return (
    <div className="max-w-3xl mx-auto space-y-10">
      <div className="text-center fade-up">
        <div className="w-14 h-14 rounded-full bg-[#C46B4E]/15 flex items-center justify-center mx-auto">
          <Heart className="w-6 h-6 text-[#C46B4E]" />
        </div>
        <p className="text-xs tracking-[0.2em] uppercase text-[#C46B4E] font-semibold mt-5">Give as You Feel Led</p>
        <h1 className="font-heading text-5xl text-[#2A2621] mt-2">Sow into this ministry</h1>
        <p className="text-[#615A50] mt-3 leading-relaxed max-w-xl mx-auto">
          The Peace Plot is sustained by the prayerful generosity of members like you. Every gift is freely
          given and freely received — it helps us share daily devotionals, offer Word &amp; Wellness, and walk
          alongside one another in Christ. "Every man according as he purposeth in his heart, so let him give."
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-6">
        {methods.map((m) => (
          <div key={m.id} className="rounded-2xl border border-[#D5CEBF] bg-[#F3EFE4] p-7" data-testid={`donate-${m.id}`}>
            <p className="text-sm font-semibold uppercase tracking-wide text-[#3D5844]">{m.label}</p>
            <p className="font-heading text-2xl text-[#2A2621] mt-2 break-all">{m.value}</p>
            {m.note && <p className="text-sm text-[#615A50] mt-2 leading-relaxed whitespace-pre-wrap">{m.note}</p>}
            <button onClick={() => copy(m.value, m.id)} data-testid={`donate-${m.id}-copy`} className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#3D5844] text-white text-sm font-medium hover:bg-[#2F4535] transition-colors">
              {copied === m.id ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />} Copy
            </button>
          </div>
        ))}
        {methods.length === 0 && <p className="text-[#615A50] sm:col-span-2 text-center" data-testid="donate-empty">Giving options coming soon.</p>}
      </div>

      <div className="rounded-[2rem] overflow-hidden relative h-56">
        <img src={QUOTE_IMG} alt="Open hands forming a heart" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#3D5844]/55 flex flex-col items-center justify-center text-center px-6">
          <p className="font-heading text-3xl text-[#FAF7EE] max-w-lg">"God loveth a cheerful giver."</p>
          <p className="mt-3 text-sm text-[#FAF7EE]/85">— 2 Corinthians 9:7 (KJV)</p>
        </div>
      </div>
    </div>
  );
}
